import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";

/**
 * NotFound — friendly 404 fallback so users landing on an unknown or
 * stale route inside the app never see a blank white screen. Renders
 * outside AppShell so it works for BOTH public and app-shell URLs.
 */
export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div
      className="min-h-[100dvh] flex items-center justify-center px-6 py-12 bg-page"
      data-testid="not-found-page"
    >
      <div className="max-w-md w-full text-center">
        <p
          className="ux-caption uppercase font-semibold mb-2"
          style={{ letterSpacing: "0.08em" }}
        >
          Error 404
        </p>
        <h1 className="ux-h1 mb-2" data-testid="not-found-title">
          Page not found
        </h1>
        <p className="ux-helper mb-6">
          The link you followed may be broken, or the page may have moved. Let&apos;s get you back on track.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="ux-btn ux-btn-ghost inline-flex items-center gap-2"
            data-testid="not-found-back-btn"
          >
            <ArrowLeft className="w-4 h-4" /> Go back
          </button>
          <Link
            to="/app"
            className="ux-btn ux-btn-primary inline-flex items-center gap-2"
            data-testid="not-found-home-btn"
          >
            <Home className="w-4 h-4" /> Go to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
